<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

onMounted(async () => {
  await store.dispatch('auth/getUserInfo');
});

export default {};
</script>

<template>
  <div class="fail-container">
    <div class="card">
      <h2 class="title">Оплата не прошла</h2>
      <p class="desc">
        К сожалению, платеж не был завершён.<br>
        Попробуйте ещё раз или используйте другой способ оплаты.
      </p>

      <el-button
        type="primary"
        size="large"
        class="btn"
        @click="$router.push('/billing')"
      >
        Вернуться к оплате
      </el-button>

      <el-button
        type="default"
        size="large"
        class="btn mt-2"
        @click="$router.push('/')"
      >
        В личный кабинет
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.fail-container {
  width: 100%;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  background: #ffffff;
  padding: 40px 50px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  text-align: center;
  max-width: 420px;
  width: 100%;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #dc2626; /* red */
  margin-bottom: 15px;
}

.desc {
  font-size: 16px;
  color: #374151;
  margin-bottom: 30px;
}

.btn {
  width: 100%;
}
</style>
